import { useEffect, useRef } from "react"
// tog'a #3355/#3408 (2026-10-04): AI o'qigan ro'yxatni bo'lim formasiga o'tkazish — sessionStorage orqali bir martalik «yuk».
// AiListImport oynasi yozadi, forma (SaleForm / PurchaseForm / OrderForm) ochilganda o'qiydi va o'chiradi.
export type AiPrefillTarget = "sale" | "purchase" | "order" | "orderToMain"   // orderToMain — hamkor/magazin «Заказ поставщику» (tog'a #3485)
export interface AiPrefillRow {
  productId: number
  supplierProductId?: number   // yetkazuvchi katalogidagi id (orderToMain)
  name: string
  article: string
  barCode: string
  stock: number
  price: number          // katalog (sotuv) narxi $
  costPriceUSD: number
  discount: number
  qty: number
  paperPrice?: number | null   // qog'ozdagi narx (zakupkada narx sifatida qo'yiladi)
}
const KEY = "aiPrefill"

export function setAiPrefill(target: AiPrefillTarget, rows: AiPrefillRow[]) {
  try { sessionStorage.setItem(KEY, JSON.stringify({ target, rows, at: Date.now() })) } catch {}
  // forma allaqachon ochiq/mount bo'lgan bo'lsa (shu sahifada turgan bo'lsa) — hodisa orqali ham xabar beriladi
  setTimeout(() => { try { window.dispatchEvent(new CustomEvent("ai-prefill", { detail: target })) } catch {} }, 300)
}

/** Shu forma uchun yuk bo'lsa qaytaradi va o'chiradi (10 daqiqadan eski yuk e'tiborsiz). */
export function takeAiPrefill(target: AiPrefillTarget): AiPrefillRow[] | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const j = JSON.parse(raw)
    if (j?.target !== target) return null
    // guruhlangan sahifada forma ikki nusxada bo'lishi mumkin — ikkalasi ham o'qishi uchun yuk 3 s dan keyin o'chiriladi
    setTimeout(() => { try { sessionStorage.removeItem(KEY) } catch {} }, 3000)
    if (!Array.isArray(j.rows) || Date.now() - Number(j.at || 0) > 10 * 60 * 1000) return null
    return j.rows as AiPrefillRow[]
  } catch { return null }
}

/** PickedProduct (ProductMultiPick) ko'rinishi — formalarning handlePick funksiyasi qabul qiladi */
export const toPicked = (r: AiPrefillRow) => ({
  productId: r.productId, name: r.name, article: r.article || "", barCode: r.barCode || "",
  stock: Number(r.stock || 0), price: Number(r.price || 0), discount: Number(r.discount || 0), costPriceUSD: Number(r.costPriceUSD || 0),
})

/** Forma ichida: ochilganda va «ai-prefill» hodisasida yukni bir marta qo'llaydi (apply — formaning handlePick + soni/narx) */
export function useAiPrefill(target: AiPrefillTarget, apply: (rows: AiPrefillRow[]) => void) {
  const done = useRef(0)
  const applyRef = useRef(apply)
  applyRef.current = apply
  useEffect(() => {
    const tekshir = () => {
      const rows = takeAiPrefill(target)
      if (rows && rows.length && Date.now() - done.current > 4000) { done.current = Date.now(); applyRef.current(rows) }
    }
    tekshir()
    const on = (e: any) => { if (e?.detail === target) tekshir() }
    window.addEventListener("ai-prefill", on)
    return () => window.removeEventListener("ai-prefill", on)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
